'use client';

import MetricLineChart from '../MetricLineChart';
import MetricGauge from '../MetricGauge';
import MetricBarChart from '../MetricBarChart';

// Sample data: MTTR percentiles over time
const percentileData = [
  { name: 'Week 1', P50: 85, P75: 145, P95: 280 },
  { name: 'Week 2', P50: 78, P75: 132, P95: 265 },
  { name: 'Week 3', P50: 70, P75: 120, P95: 245 },
  { name: 'Week 4', P50: 65, P75: 110, P95: 225 },
  { name: 'Week 5', P50: 58, P75: 98, P95: 205 },
  { name: 'Week 6', P50: 52, P75: 88, P95: 185 },
];

// Sample data: MTTR components breakdown
const componentsData = [
  { name: 'Detection', minutes: 8, percentage: 19 },
  { name: 'Acknowledgment', minutes: 3, percentage: 7 },
  { name: 'Investigation', minutes: 15, percentage: 36 },
  { name: 'Fix Deploy', minutes: 10, percentage: 24 },
  { name: 'Verification', minutes: 6, percentage: 14 },
];

export function MTTRPercentilesChart() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">⏱️ MTTR Improvement Over Time</h3>
      <MetricLineChart
        data={percentileData}
        lines={[
          { dataKey: 'P50', name: 'P50 (Median)', color: '#6FCF97' },
          { dataKey: 'P75', name: 'P75', color: '#4A90E2' },
          { dataKey: 'P95', name: 'P95', color: '#E89841' },
        ]}
        xAxisLabel="Week"
        yAxisLabel="MTTR (minutes)"
        targetLine={60}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing consistent MTTR improvement. Median recovery time improved from
        85 minutes to 52 minutes. Green line shows Elite threshold (&lt; 60 minutes).
      </p>
    </div>
  );
}

export function MTTRGauge() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🎯 Current MTTR Performance</h3>
      <MetricGauge
        value={42}
        max={240}
        label="Mean Time to Recovery"
        unit=" min"
        ranges={[
          { min: 0, max: 25, color: '#6FCF97', label: 'Elite' },
          { min: 25, max: 60, color: '#4A90E2', label: 'High' },
          { min: 60, max: 90, color: '#F2C94C', label: 'Medium' },
          { min: 90, max: 100, color: '#EB5757', label: 'Low' },
        ]}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current MTTR of 42 minutes places the team in the Elite category (&lt; 60 minutes).
        This indicates strong incident response capabilities.
      </p>
    </div>
  );
}

export function MTTRBreakdownChart() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🔍 MTTR Component Breakdown</h3>
      <MetricBarChart
        data={componentsData}
        bars={[
          { dataKey: 'minutes', name: 'Time (minutes)', color: '#E89841' },
        ]}
        xAxisLabel="Stage"
        yAxisLabel="Average Time (minutes)"
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Investigation is the largest component at 15 minutes (36% of MTTR). Improving
        observability and runbooks can reduce this further.
      </p>
    </div>
  );
}
